import { mapGetters } from 'vuex'
import ConfigurationMobile from '@/agilis/mobile/util/ConfigurationMobile'

// Mixin providing common render utils
export default {
  name: 'ListCardMobileRenderMixin',

  data () {
    return {
      itemsPerPage: 10,
      itemsPerPageOptionsMobile: [
        {
          label: '5',
          value: 5
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '15',
          value: 15
        },
        {
          label: 'All',
          value: -1
        }],
      itemDTO: {}
    }
  },

  computed: {
    ...mapGetters({
      'mode': 'contextStore/contextMode',
      'applicationId': 'contextStore/applicationId',
      'trackerTypeId': 'contextStore/trackerTypeId'
    })
  },
  methods: {

    headerMobile (itemLayout, dataTableConfig = null) {
      const dataTableConfiguration = dataTableConfig !== null ? dataTableConfig : this.dataTableConfiguration
      return ConfigurationMobile.listTable.getHeader(itemLayout, dataTableConfiguration)
    },
    subHeaderMobile (itemLayout, dataTableConfig = null) {
      const dataTableConfiguration = dataTableConfig !== null ? dataTableConfig : this.dataTableConfiguration
      return ConfigurationMobile.listTable.getSubHeader(itemLayout, dataTableConfiguration)
    },
    columnsMobile (itemLayout, dataTableConfig = null) {
      const dataTableConfiguration = dataTableConfig !== null ? dataTableConfig : this.dataTableConfiguration
      return ConfigurationMobile.listTable.getColumnsId(itemLayout, dataTableConfiguration)
    },
    iconMobile (itemLayout) {
      return ConfigurationMobile.listTable.getIcon(itemLayout)
    }
  }
}
